import { BaseTable } from '@shared/Table'
import { IconEye } from '@shared/icons'
import { momentToString } from '@shared/utils/webHelper'
import { Col as AntCol, Row } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import {
  CLOSED_REPAIR_MANAGEMENT,
  MAINTENANCE_MANAGEMENT,
  REPAIR_MANAGEMENT,
} from 'src/routes'
import styled from 'styled-components'

import { IRepair, REPAIR_STATE, useRepairList } from '@services/repair'

type Props = {
  item: IRepair
  isEdit: boolean
}

const titleprops = {
  className: 'col-title',
  span: 4,
}

export default function RepairLogContent({ item, isEdit, ...props }: Props) {
  const { t } = useTranslation()
  const history = useHistory()

  const { logs, ticketSource, deviceType, deviceSeq, id } = item
  const { dataSource, isLoading } = useRepairList({
    // state: REPAIR_STATE.REPORTED,
    deviceType,
    deviceSeq: deviceSeq || id, //從維修管理帶入 deviceSeq | 其他設備畫面帶入 id
  })

  const gotoDetail = (r: IRepair) => {
    let path = null
    switch (r.state) {
      case REPAIR_STATE.REPORTED:
        path = REPAIR_MANAGEMENT
        break
      case REPAIR_STATE.REPAIRING:
        path = MAINTENANCE_MANAGEMENT
        break
      case REPAIR_STATE.CLOSE:
      case REPAIR_STATE.FINISH:
        path = CLOSED_REPAIR_MANAGEMENT
        break
    }
    if (path) {
      history.push(`${path}?id=${r?.id}`)
    }
  }

  const columns: ColumnsType<IRepair> = [
    {
      title: '案件編號',
      dataIndex: 'ticketNo',
    },
    {
      title: '案件進度',
      dataIndex: 'stateStr',
    },
    {
      title: '報修時間',
      dataIndex: 'createAtStr',
    },
    {
      title: '結案時間',
      dataIndex: 'closedAtStr',
    },
    {
      title: '前往查看',
      key: 'view',
      align: 'center',
      width: 90,
      render: (_, r) => <IconEye onClick={() => gotoDetail(r)} />,
    },
  ]

  return (
    <div
      className="overflow-auto"
      style={{ height: 'calc(100vh / 2)', backgroundColor: '#272727' }}>
      {!logs ? null : (
        <div
          className=" px-40 pt-24 pb-98 "
          style={{ backgroundColor: '#fff' }}>
          <div className="text-[16px] font-medium">維修歷程</div>
          <Row className="mt-8">
            {logs?.map(i => (
              <>
                <Col {...titleprops}>{t(`repair:log ${i.event}`)}</Col>
                <Col className="col-desc" span={20}>
                  <span className="text-info text-[12px]">
                    {momentToString(i.logAt, 'YYYY.MM.DD HH:mm:ss')}
                  </span>
                  {ticketSource ? ticketSource : null}
                  {i.memberDisplayName ? ` / ${i.memberDisplayName}` : null}
                  {i.note ? ` / ${i.note}` : null}
                </Col>
              </>
            ))}
          </Row>
        </div>
      )}
      <div className="px-40 py-24">
        <div className="text-[16px] font-medium text-white">
          {t(`device:${deviceType}`)} {item.deviceDisplayName}
        </div>
        <StyleTable
          columns={columns}
          loading={isLoading}
          dataSource={dataSource.content}
          pagination={false}
        />
      </div>
    </div>
  )
}

const StyleTable: any = styled(BaseTable)`
  .ant-table-thead > tr > th {
    background: #272727;
  }

  .ant-table-tbody > tr > td {
    background: #272727;
  }
`

const Col = styled(AntCol)`
  min-height: 36px;
  border-bottom: 1px solid #fff;
  font-weight: 500;

  &.col-title {
    background-color: #c0c0c0;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 0px 8px;
    font-size: 14px;
  }

  &.col-desc {
    padding: 8px;
    color: #878787;
    font-size: 13px;
  }

  :nth-child(4n) {
    background: #f4f3f3;
  }
`
